/**
 * 현재 경로 기준 메뉴 READ/WRITE 접근 상태.
 * AdminLayout이 Provider로 공급하고, 페이지·버튼은 useMenuAccess로 소비한다.
 */
import {
  resolveMenuAccessByPath,
  type MenuAccessState,
} from '@/layouts/resolveMenuAccessByPath';
import { createContext, useContext } from 'react';

export type MenuAccessContextValue = MenuAccessState;

const defaultAccess: MenuAccessContextValue = {
  menuKey: null,
  matched: false,
  canRead: true,
  canWrite: true,
  readOnly: false,
};

export const MenuAccessContext =
  createContext<MenuAccessContextValue>(defaultAccess);

export const useMenuAccess = (): MenuAccessContextValue =>
  useContext(MenuAccessContext);

/** 테스트·스토리용 — pathname만으로 접근 상태 계산 */
export const computeMenuAccess = resolveMenuAccessByPath;
